/* Shell every Pit Crew tool sits in. Same subdued notice language as ConfirmNotice:
   cream shell, dark purple header strip, square corners, sans-serif CTA. */
import React from 'react';
import { X, Lock } from "@phosphor-icons/react";
import { Link } from 'react-router-dom';
import { homeSection } from '../../lib/marketingHome';

const INK = '#2A1E5C';
const CREAM = '#FAF7F0';

export const PitCrewToolShell = ({ eyebrow, title, lead, onClose, testId, children, footer }) => (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-6"
    style={{ background: 'rgba(42, 30, 92, 0.6)' }}
    data-testid={testId}
  >
    <div
      className="relative w-full max-w-4xl max-h-[94vh] overflow-y-auto"
      style={{ background: CREAM, border: '1px solid #E0D9CB', borderRadius: 0, boxShadow: '0 24px 60px rgba(42, 30, 92, 0.2)' }}
    >
      <div className="px-6 sm:px-9 py-4 flex items-center justify-between sticky top-0 z-10" style={{ background: INK }}>
        <p className="font-body text-[11px] uppercase tracking-[0.26em]" style={{ color: 'rgba(255,255,255,0.72)' }}>
          {eyebrow}
        </p>
        <button
          onClick={onClose}
          className="p-1 transition-opacity hover:opacity-60"
          style={{ color: 'rgba(255,255,255,0.72)' }}
          aria-label="Close"
          data-testid={`${testId}-close`}
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="px-6 sm:px-9 py-7 sm:py-8">
        <h2 className="font-heading text-2xl font-bold mb-2" style={{ color: INK }}>{title}</h2>
        {lead && (
          <p className="font-body text-sm leading-relaxed mb-6 max-w-2xl" style={{ color: '#5D5A6B' }}>{lead}</p>
        )}
        {children}
        {footer}
      </div>
    </div>
  </div>
);

export const PitCrewLocked = ({ toolName, blurb, onClose, testId }) => (
  <PitCrewToolShell eyebrow="Pit Crew tools" title={`${toolName} rides with your Season Pass`} onClose={onClose} testId={testId}>
    <div className="p-6 mb-6" style={{ background: '#FFFFFF', border: '1px solid #E8E2D5' }}>
      <div className="flex items-start gap-3">
        <Lock className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: '#8B7E6A' }} />
        <div>
          <p className="font-body text-sm leading-relaxed mb-2" style={{ color: INK }}>{blurb}</p>
          <p className="font-body text-sm leading-relaxed" style={{ color: '#5D5A6B' }}>
            The Pit Crew tools come with the Season Pass, alongside the full 52-relay sheet, your Pit
            Stops, and the bonus bank. Your free sprint keeps the calculator itself.
          </p>
        </div>
      </div>
    </div>
    <div className="flex flex-wrap items-center gap-5">
      <Link
        to={homeSection('season-pass')}
        className="font-body text-sm font-semibold px-8 py-3.5 transition-opacity hover:opacity-90"
        style={{ background: INK, color: '#F2EFE7', borderRadius: 0 }}
        data-testid={`${testId}-cta`}
      >
        See Season Pass
      </Link>
      <button
        onClick={onClose}
        className="font-body text-sm underline transition-opacity hover:opacity-70"
        style={{ color: '#8B7E6A' }}
        data-testid={`${testId}-back-btn`}
      >
        Back to the calculator
      </button>
    </div>
  </PitCrewToolShell>
);

export const ToolLabel = ({ children }) => (
  <label className="font-body text-[11px] uppercase tracking-[0.18em] block mb-1.5" style={{ color: '#8B7E6A' }}>
    {children}
  </label>
);

export const ToolInput = ({ prefix, suffix, ...props }) => (
  <div className="flex items-center" style={{ background: '#FFFFFF', border: '1px solid #E0D9CB' }}>
    {prefix && <span className="font-body text-sm pl-3" style={{ color: '#8B7E6A' }}>{prefix}</span>}
    <input
      {...props}
      className="w-full font-body text-sm px-3 py-2.5 bg-transparent focus:outline-none"
      style={{ color: INK }}
    />
    {suffix && <span className="font-body text-sm pr-3" style={{ color: '#8B7E6A' }}>{suffix}</span>}
  </div>
);

export const ToolApplyBar = ({ note, applyLabel, onApply, onClose, disabled, testId }) => (
  <div className="flex flex-wrap items-center gap-5 mt-7">
    <button
      onClick={onApply}
      disabled={disabled}
      className="font-body text-sm font-semibold px-8 py-3.5 transition-opacity hover:opacity-90 disabled:opacity-40"
      style={{ background: INK, color: '#F2EFE7', borderRadius: 0 }}
      data-testid={`${testId}-apply-btn`}
    >
      {applyLabel}
    </button>
    <button
      onClick={onClose}
      className="font-body text-sm underline transition-opacity hover:opacity-70"
      style={{ color: '#8B7E6A' }}
      data-testid={`${testId}-cancel-btn`}
    >
      Cancel
    </button>
    {note && <p className="font-body text-xs" style={{ color: '#8B7E6A' }}>{note}</p>}
  </div>
);

export const COLORS = { INK, CREAM };
